import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";
import { toArray } from "Common/utils/list";
const getToken = () => localStorage.getItem("token");

export const fetchCourses = async (id = null) => {
  try {
    // The courses list is now server-paginated ({ items, ... }). Request the
    // backend max page size so the existing client-side group filter still has
    // the full set to work with, and normalize to a plain array.
    const base = `${process.env.REACT_APP_API_URL}/Library/Get-Courses-List`;
    const url = id
      ? `${base}?id=${id}&pageNumber=1&pageSize=30`
      : `${base}?pageNumber=1&pageSize=30`;

    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    return toArray(response.data);
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};


export const getCourseDetail = async (id) => {
  try {
    const response = await api.get(`/Library/Get-Course-Detail?courseId=${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching course details:", error);
    throw error;
  }
};

export const addCourse = async (courseData) => {
  try {
    const response = await api.post("/Library/AddCourse", courseData, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding course:", error);
    throw error;
  }
};
// Full business-group records (incl. createdOn) for the Admin management grid.
// The list is now server-paginated; request the backend max and normalize.
export const getBusinessGroups = async () => {
  try {
    const response = await api.get(`${API.businessGroup.getList}?pageNumber=1&pageSize=30`);
    return toArray(response.data);
  } catch (error) {
    throw error;
  }
};

// Lightweight business-group list (id + name) for dropdowns/selectors.
// Lookup endpoints return a plain array of all groups (no pagination).
export const getBusinessGroupsLookup = async () => {
  try {
    const response = await api.get("/BusinessGroup/Lookup");
    return toArray(response.data);
  } catch (error) {
    throw error;
  }
};

export const getBusinessGroupDetail = async (id) => {
  try {
    const response = await api.get(API.businessGroup.getDetails(id));
    console.log("Business Group Detail:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Business Group Detail:", error);
    throw error;
  }
};

export const addBusinessGroupField = async (field) => {
  try {
    const response = await api.post(API.businessGroupField.addField, field);
    return response.data;
  }
  catch (error) {
    console.error("Error Adding Business Group Field", error);
    throw error;
  }
};
 
